import { RootState } from '..';

export const selectParameterSets = (state: RootState) =>
  state.parameterSets.parameterSets;

export const selectParameterSetErrors = (state: RootState) =>
  state.parameterSets.errors;

export const selectParameterSetTypes = (state: RootState) =>
  state.parameterSets.parameterSetTypes;
